import { API_URL } from './config'

async function post<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  const payload = await res.json().catch(() => null)
  if (!res.ok) {
    // Nest returns either a string or an array of validation messages.
    const message = payload?.message
    throw new Error(Array.isArray(message) ? message[0] : message || `HTTP ${res.status}`)
  }
  return payload as T
}

export interface SignupResult {
  organization: { id: string; name: string; slug: string }
  portal_url: string
  message: string
  /** Only present when the server has no mail provider and could not send the link. */
  confirm_url?: string
}

export const api = {
  checkSlug: async (slug: string) => {
    const res = await fetch(
      `${API_URL}/organizations/slug-available?slug=${encodeURIComponent(slug)}`,
    )
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return res.json() as Promise<{ slug: string; valid: boolean; available: boolean }>
  },

  signup: (body: {
    organization_name: string
    slug: string
    email: string
    password: string
    first_name: string
    last_name?: string
    accept_terms: boolean
    accept_privacy: boolean
  }) => post<SignupResult>('/organizations/signup', body),
}

/** Turns an organisation name into the subdomain we suggest for it. */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 63)
}
